<template>
	<nav
		v-if="$store.state.mainNavOpen"
		class="main-navigation-modal"
	>
		<focus-lock :returnFocus="true">
			<button
				type="button"
				class="main-navigation-modal__close btn--no-style"
				@click="closeMenu"
			>
				<svg svg-inline="" focusable="false" role="presentation" width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg"><path d="M15.382 12.583l9.176 9.175-2.85 2.851-9.176-9.175-9.182 9.18-2.862-2.861 9.181-9.181L.494 3.396l2.85-2.85L12.52 9.72 21.701.54l2.863 2.862z" fill="#717171" fill-rule="evenodd"/></svg>
				<div>Close</div>
			</button>

			<ul class="main-navigation-modal__links stripped-list">
				<li class="main-navigation-modal__item">
					<router-link
						:to="{ name: $GLOBALS.ROUTE_HOME }"
						class="main-navigation-modal__link"
						@click.native="closeMenu"
					>
						Home
					</router-link>
				</li>
				<li class="main-navigation-modal__item">
					<button
						@click="$store.commit('modalVisible', {modal: 'savedInfo', boolean: true})"
						type="button"
						class="main-navigation-modal__link btn--no-style"
					>
						My Saved Info
					</button>
				</li>
				<li class="main-navigation-modal__item">
					<div class="main-navigation-modal__link main-navigation-modal__link-with-sub">Browse Topics</div>
					<ul class="stripped-list main-navigation-modal__sub-menu">
						<li
							v-for="(topic, index) in $store.state.topics"
							:key="index"
						>
							<router-link
								:to="{ name: $GLOBALS.ROUTE_TOPIC, params: { slug: topic.slug } }"
								class="main-navigation-modal__sub-link"
								@click.native="closeMenu"
							>
								{{ topic.title }}
							</router-link>
						</li>
					</ul>
				</li>
				<li class="main-navigation-modal__item">
					<router-link
						:to="{ name: $GLOBALS.ROUTE_RECIPIENTS }"
						class="main-navigation-modal__link"
						@click.native="closeMenu"
					>
						Recipient Types
					</router-link>
				</li>
				<li class="main-navigation-modal__item">
					<router-link
						to="/information"
						class="main-navigation-modal__link"
						@click.native="closeMenu"
					>
						Information
					</router-link>
				</li>
				<li class="main-navigation-modal__item">
					<router-link
						to="/contact-us"
						class="main-navigation-modal__link"
						@click.native="closeMenu"
					>
						Contact Us
					</router-link>
				</li>
			</ul>

			<ul class="main-navigation-modal__supplimentary-links stripped-list">
				<li class="main-navigation-modal__supplimentary-item">
					<router-link
						to="/privacy-policy"
						class="main-navigation-modal__supplimentary-link"
						@click.native="closeMenu"
					>
						Privacy Policy
					</router-link>
				</li>
				<li class="main-navigation-modal__supplimentary-item">
					<router-link
						to="accessibility"
						class="main-navigation-modal__supplimentary-link"
						@click.native="closeMenu"
					>
						Accessibility
					</router-link>
				</li>
			</ul>
		</focus-lock>
	</nav>
</template>

<script>
// Mixins
import { modal } from '@/mixins/modal.js';

// Styles
import '@/sass/components/_main-navigation.scss';

// Components
import FocusLock from 'vue-focus-lock';

export default {
	mixins: [modal],
	components: {
		FocusLock
	},
	watch: {
		$route() {
			this.closeMenu();
		}
	},
	methods: {
		closeMenu() {
			this.$store.commit('mainNavOpen', false);
			this.removeModalBodyClass();
		},
		browseTopics() {
			this.$store.commit('mainNavOpen', false);
			this.$store.commit('modalVisible', {
				modal: 'chooseTopic',
				boolean: true
			});
		},
		savedInfo() {
			this.$store.commit('mainNavOpen', false);
			this.$store.commit('modalVisible', { modal: 'savedInfo', boolean: true });
		}
	}
};
</script>
